import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=7f8dd4f4&scoped=true"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=7f8dd4f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dd4f4",
  null
  
)

export default component.exports